// 고객 「내 현장」 첫 화면에 쓰는 계산 — 진행률·최근 일지(경로는 core customer-visible 한 벌).

import type { CustomerDay, CustomerLog, CustomerPhase, CustomerPhoto } from "@buildpy/core/modules/project/customer-visible";

export interface PhaseProgress {
  done: number;
  total: number;
  percent: number;
  active: CustomerPhase | null;
}

// 끝난 공정 수 / 전체 — 보류도 전체에는 센다.
export const phaseProgressOf = (phases: readonly CustomerPhase[]): PhaseProgress => {
  const done = phases.filter((p) => p.status === "DONE").length;
  const total = phases.length;
  return {
    done,
    total,
    percent: total === 0 ? 0 : Math.round((done / total) * 100),
    active: phases.find((p) => p.status === "ACTIVE") ?? null,
  };
};

export interface LatestLog {
  date: string;
  log: CustomerLog;
  photos: CustomerPhoto[];
}

// 날짜 내림차순 days 에서 일지가 있는 첫 날의 첫 일지 — 사진은 그날 것.
export const latestLogOf = (days: readonly CustomerDay[]): LatestLog | null => {
  const day = days.find((d) => d.logs.length > 0);
  return day ? { date: day.date, log: day.logs[0], photos: day.photos } : null;
};
